/** @jsx h */
import { h } from 'preact'

const Snackbar = ({ id, message }) => (
  <div id={id} class='Snackbar BodyUI--emphasis'>
    {message}
  </div>
)

export default Snackbar
